import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppThunkDispatch } from 'state/store';
import intl from 'react-intl-universal';
import {
  resetDeleteUserResult,
  selectDeleteUserResult,
} from 'state/UsersManagement/usersManagementSlice';
import useSnackbarNotification from 'Hooks/useSnackbarNotification';

const DeleteUserSnackbar = () => {
  const dispatch = useAppThunkDispatch();
  const deleteUserResult = useSelector(selectDeleteUserResult);
  const {
    showNotification,
    SnackbarNotification,
    snackbarProps,
    isNotificationVisible,
    hideNotification,
  } = useSnackbarNotification();

  const handleHideOrCloseNotification = useCallback(() => {
    hideNotification();
    dispatch(resetDeleteUserResult());
  }, [hideNotification, dispatch]);

  useEffect(() => {
    if (deleteUserResult === 'success') {
      showNotification({
        notificationVariant: 'success',
        notificationTitle: intl.get(
          'SETTINGS_PAGE.USER_PAGE.DELETE_USER.SUCCESS_MESSAGE'
        ),
      });
    } else if (deleteUserResult === 'failed') {
      showNotification({
        notificationVariant: 'error',
        notificationTitle: intl.get('SNACKBAR_ERROR_NOTIFICATION_TITLE'),
        notificationMessage: intl.get(
          'SETTINGS_PAGE.USER_PAGE.DELETE_USER.ERROR_MESSAGE'
        ),
      });
    }
  }, [deleteUserResult, showNotification]);

  useEffect(() => {
    return () => {
      handleHideOrCloseNotification();
    };
  }, [handleHideOrCloseNotification]);

  if (isNotificationVisible && snackbarProps) {
    return (
      <SnackbarNotification
        {...snackbarProps}
        onCloseCallback={handleHideOrCloseNotification}
      />
    );
  }

  return null;
};

export default DeleteUserSnackbar;
